import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import './HtGoldLobbyHuayNav.css'

const TABS = [
  { to: '/lobby-huay/listall', match: 'listall', label: 'แทงหวย', icon: 'fas fa-ticket-alt', end: true },
  { to: '/lobby-huay/set', match: 'set', label: 'เลขชุด', icon: 'fas fa-layer-group', end: false },
  { to: '/lobby-huay/slip', match: 'slip', label: 'โพยหวย', icon: 'fas fa-receipt', end: false },
  { to: '/lobby-huay/result', match: 'result', label: 'ผลหวย', icon: 'fas fa-trophy', end: false },
] as const

function shouldHideTabs(pathname: string): boolean {
  return (
    pathname.includes('/yeekee') ||
    pathname.includes('/lottery-terms') ||
    pathname.includes('/bet') ||
    pathname.includes('/set-lotto-game') ||
    pathname.includes('/set/create') ||
    pathname.includes('/set/edit') ||
    pathname.includes('/win-number') ||
    pathname.includes('/slip/detail')
  )
}

function isTabActive(pathname: string, match: string): boolean {
  if (match === 'listall') {
    return (
      pathname === '/lobby-huay' ||
      pathname === '/lobby-huay/' ||
      pathname.includes('/lobby-huay/listall')
    )
  }
  if (match === 'set') {
    return pathname.includes('/lobby-huay/set') && !pathname.includes('/set-lotto-game')
  }
  if (match === 'slip') {
    return pathname.includes('/lobby-huay/slip')
  }
  if (match === 'result') {
    return pathname.includes('/lobby-huay/result') && !pathname.includes('/yeekee/result')
  }
  return false
}

/** Slim lobby tabs for HT Gold (parity with HTD v-pills, without HTD hero). */
const HtGoldLobbyHuayNav: React.FC = () => {
  const { pathname } = useLocation()
  if (shouldHideTabs(pathname)) return null

  return (
    <nav className="htg-lobby-tabs" role="tablist" aria-label="เมนูหวย">
      {TABS.map((tab) => {
        const active = isTabActive(pathname, tab.match)
        return (
          <NavLink
            key={tab.match}
            to={tab.to}
            end={tab.end}
            role="tab"
            aria-selected={active}
            className={() => `htg-lobby-tabs__link${active ? ' is-active' : ''}`}
          >
            <i className={tab.icon} aria-hidden />
            <span>{tab.label}</span>
          </NavLink>
        )
      })}
    </nav>
  )
}

export default HtGoldLobbyHuayNav
